import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import store from '../store/configureStore';

import * as HeaderActions from '../actions/Header';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as Header from '../constants/Header';
import UserSelectMoffRaku from '../components/Organisms/UserSelectMoffRaku';

type AllState = ReturnType<typeof store.getState>;

const UserSelectMoffRakuContainer: FC = () => {
  const dispatch = useDispatch();
  const moffAPI = useSelector((state: AllState) => state.moffAPI);

  useEffect(() => {
    (async () => {
      document.title = '利用者一覧';
      dispatch(HeaderActions.setPage(Header.USER_SELECT_MOFF_RAKU));
      await dispatch(MoffAPIActions.getUsers());
      dispatch(MoffAPIActions.duplicateRepeatSort());
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <UserSelectMoffRaku moffAPI={moffAPI} />;
};

export default UserSelectMoffRakuContainer;
